import React from 'react'
import { injectIntl } from 'react-intl'
import ArrowLeftIcon from './ArrowLeftIcon'
import ArrowRightIcon from './ArrowRightIcon'

const BackIcon = props => {
  let { intl } = props
  if (intl.locale === 'en') {
    return <ArrowLeftIcon {...props} />
  } else {
    return <ArrowRightIcon {...props} />
  }
}

export default injectIntl(BackIcon)
